import { createStore } from 'vuex';
import { generalStore as general } from '@/store/generalStore';

export const generalStore = createStore(general);
